export const prime = {
  name: 'Amazon Prime',
  id: 'prime',
  url: 'https://www.primevideo.com/',
  color: '#4aa7dc',
  compatible: false
}
